import UAParser from 'ua-parser-js'

const blackListedBrowser = new Set([
  'Amaya', 'Android Browser', 'Arora', 'Avant', 'Baidu', 'Blazer', 'Bolt', 'Camino', 'Chimera',
  'Chromium', 'Comodo Dragon', 'Conkeror', 'Dillo', 'Dolphin', 'Doris', 'Epiphany', 'Fennec',
  'Firebird', 'Flock', 'GoBrowser', 'iCab', 'ICE Browser', 'IceApe', 'IceCat', 'IceDragon',
  'Iceweasel', 'Iron', 'Jasmine', 'K-Meleon', 'Konqueror', 'Kindle', 'Links',
  'Lunascape', 'Lynx', 'Maemo', 'Maxthon', 'Midori', 'Minimo', 'MIUI Browser',
  'Mosaic', 'Netfront', 'Netscape', 'NetSurf', 'Nokia', 'OmniWeb',
  'Phoenix', 'Polaris', 'QQBrowser', 'RockMelt', 'Silk', 'Skyfire', 'SeaMonkey', 'SlimBrowser',
  'Swiftfox', 'Tizen', 'UCBrowser', 'Vivaldi', 'w3m', 'WeChat', 'Yandex'
])

const parseVersion = function (str) {
  if (typeof str !== 'string') {
    return false
  }
  const x = str.split('.')
  const major = parseInt(x[0]) || 0
  const minor = parseInt(x[1]) || 0
  const patch = parseInt(x[2]) || 0
  return {major, minor, patch}
}

const upperOrEqual = function (v, from) {
  const vFrom = parseVersion(from)
  return v.major > vFrom.major ||
    (v.major === vFrom.major && v.minor >= vFrom.minor) ||
    (v.major === vFrom.major && v.minor === vFrom.minor && v.patch >= vFrom.patch)
}

const check = function () {
  const parser = new UAParser()
  const p = parser.getResult()
  // console.debug(p)
  const browserName = p.browser.name
  const browserVersion = parseVersion(p.browser.version)
  const osName = p.os.name
  const osVersion = parseVersion(p.os.version)
  switch (true) {
    case blackListedBrowser.has(browserName):
      return false
    case /^Android/i.test(osName):
      return upperOrEqual(osVersion, '4.0')
    case /^iOS/i.test(osName):
      return upperOrEqual(osVersion, '8.3')
    case /^Windows (Phone|Tablet)/i.test(osName):
      return upperOrEqual(osVersion, '8.1')
    case /^Chrome/i.test(browserName):
      return upperOrEqual(browserVersion, '48')
    case /^Firefox/i.test(browserName):
      return upperOrEqual(browserVersion, '44')
    case /^Opera/i.test(browserName):
      return upperOrEqual(browserVersion, '35')
    case /^IE/i.test(browserName):
      return upperOrEqual(browserVersion, '11')
    case /Safari$/i.test(browserName):
      return upperOrEqual(browserVersion, '8')
    default:
      console.log('Unable to test the compatibility of this browser. Test assumed to be positive.', p)
      return true
  }
}

export default check



// WEBPACK FOOTER //
// ./src/app/compatibility.js